import { get } from 'lodash'
import { connect } from 'react-redux'

import { auth, common, formData, payment, voucher } from '../../../constants/actions'
import {
  getCurrentRegistrationId,
  getFormInfo,
  getFormMessages,
  getFormSettings,
  getIsAuthenticated,
  getPaymentProviders,
  getResetTimer,
  getRoktConfiguration,
  getStartTimer,
  getTeamFormType,
  getVoucherSessionId,
} from '../../../selectors'
import FormRouteComponent from './component'

export const mapStateToProps = state => ({
  formSettings: getFormSettings(state),
  isAuthenticated: getIsAuthenticated(state),
  startTimer: getStartTimer(state),
  resetTimer: getResetTimer(state),
  currentRego: getCurrentRegistrationId(state),
  messages: getFormMessages(state),
  paymentProviders: getPaymentProviders(state),
  voucherSessionId: getVoucherSessionId(state),
  useSubEvents: get(state, 'formInfo.form.useSubEvents'),
  subEvents: get(state, 'formInfo.subEvents'),
  addOn: get(state, 'formInfo.addOn'),
  isTeamEvent: get(state, 'formInfo.event.isTeamEvent'),
  isTeamReset: get(state, 'formData.team.isTeamReset'),
  roktConfiguration: getRoktConfiguration(state),
  teamFormType: getTeamFormType(state),
  formInfo: getFormInfo(state),
  registeredTeam: get(state, 'formData.team'),
  registrations: get(state, 'formData.registrations'),
})

export default connect(mapStateToProps, {
  signout: auth.signout,
  setStartTimer: common.setStartTimer,
  resetForm: formData.resetForm,
  setSessionId: formData.setSessionId,
  resetVoucher: voucher.resetVoucher,
  showLoading: common.setShowLoadingIndicator,
  paymentSuccessful: payment.paymentSuccessful,
})(FormRouteComponent)
